import cn from 'classnames';
import React, {useEffect, useState} from 'react';
import axios from 'axios';
// import {sendCode} from '../../../api/sms';
import Input from '../input/input.jsx';

import s from './index.scss';

const KEY = 'HYEBRKLD';
let keyFlag = true;

const Cpt = ({mobile, err, onChange}) => {
    const [time, setTime] = useState(
        localStorage.getItem(KEY) ?
            (
                new Date().getTime() - Number(localStorage.getItem(KEY)) > 60 * 1000 ?
                    0 :
                    60 - Math.floor((new Date().getTime() - Number(localStorage.getItem(KEY))) / 1000)
            ) :
            0
    );
    const [inputErr, setInputErr] = useState('');
    useEffect(() => {
        let timer;
        if (time > 0) {
            timer = setTimeout(() => {
                setTime(time - 1);
            }, 1000);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [time]);
    useEffect(() => {
        keyFlag = true;
    }, []);
    return (
        <Input
            type="number"
            err={err || inputErr}
            onChange={v => {
                onChange(v);
                setInputErr('');
            }}
            placeholder="请输入验证码"
            maxLength={4}
            verify={v => {
                if (v.length != 4) {
                    throw new Error('请输入4位短信验证码');
                }
                return true;
            }}
            addonAfter={
                (
                    <div
                        className={cn(s.code, {[s.disabled]: time > 0})}
                        onClick={async () => {
                            if (!keyFlag) {
                                return;
                            }
                            if (time > 0) {
                                return;
                            }
                            if (!mobile) {
                                return;
                            }
                            try {
                                keyFlag = false;
                                // await sendCode({phone: mobile});
                                await axios.post(`${window.config.apiBaseURL}/sms/send-code`, {phone: mobile}).then(res => {
                                    const {data} = res.data
                                    if (res.data.code === 0) {
                                        setTime(60);
                                        keyFlag = true;
                                        localStorage.setItem(KEY, new Date().getTime()
                                            .toString());
                                    }else{
                                        throw new Error(data);
                                    }
                                });

                            } catch (error) {
                                keyFlag = true;
                                setInputErr(error.message);
                            }
                        }}
                    >
                        {
                            time > 0 ?
                                `${time}秒后重发` :
                                '获取验证码'
                        }
                    </div>
                )
            }
        />
    );
};

export default Cpt;
